import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function PremiumPrompt({ feature = 'this feature', inline = false }) {
  const { user } = useAuth();
  const navigate = useNavigate();

  const containerClass = inline ? 'premium-prompt premium-prompt--inline' : 'premium-prompt';

  if (!user) {
    return (
      <div className={containerClass}>
        <div className="premium-prompt-icon">★</div>
        <h3>Premium feature</h3>
        <p>Sign in or create a free account, then subscribe to unlock {feature}.</p>
        <div className="premium-prompt-actions">
          <button className="btn-primary" onClick={() => navigate('/login')}>Sign In</button>
          <button className="btn-secondary" onClick={() => navigate('/signup')}>Create Account</button>
        </div>
      </div>
    );
  }

  return (
    <div className={containerClass}>
      <div className="premium-prompt-icon">★</div>
      <h3>Premium feature</h3>
      <p>Upgrade to ValueSieve Premium to unlock {feature}.</p>
      <div className="premium-prompt-actions">
        <button className="btn-primary" onClick={() => navigate('/subscribe')}>View Plans</button>
      </div>
    </div>
  );
}
